import React from 'react';
import ReactDOM from 'react-dom';
import Cookies from 'js-cookie';
import { ActivityCalendar } from 'react-activity-calendar';
import { FiActivity, FiAward, FiBox, FiBriefcase, FiCalendar, FiCheckCircle, FiClock, FiLoader, FiLogOut, FiMapPin, FiMoreVertical, FiPlus, FiThumbsUp, FiTrendingUp, FiUser, FiUserPlus, FiX } from 'react-icons/fi';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip } from 'recharts';
import styles from '../Dashboard.module.css';
import * as utils from '../../../utils/utils';
import Sidebar from '../../Sidebar/Sidebar';
import HQDialog from '../../HQDialog/HQDialog';
import HQToast from '../../HQToast/HQToast';

export default class DashboardEducation extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			nickname: this.props.nickname || '',

			errorText: '',

            isLoadingEducation: false,
			isSavingEducation: false,

            educationErrorText: '',
            saveEducationErrorText: '',

            isAddEditEducationDialogOpen: false,

            newEducationText: '',
			editingEducationUserSchoolMajorID: null,

            openEducationMenuID: 0,

            deletingEducationIDs: [],

            confirmDeleteEducationID: 0,

			educationList: [],
		};

		this.educationMenuRefs = {};
	};

	componentDidMount() {
		if (!utils.isLoggedIn()) {
			window.location.href = '/signin';
			return;
		}

		document.addEventListener('mousedown', this.onDocumentPointerDown);
		document.addEventListener('touchstart', this.onDocumentPointerDown);

        this.loadEducationData();
	};

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.onDocumentPointerDown);
		document.removeEventListener('touchstart', this.onDocumentPointerDown);
	};

	// normalizeCalendarData = (graph) => {
	// 	const maxCount = graph.reduce((max, item) => {
	// 		return Math.max(max, item.count || 0);
	// 	}, 0);

	// 	return graph.map((item) => {
	// 		const count = Number(item.count) || 0;

	// 		let level = 0;
	// 		if (count > 0 && maxCount > 0) {
	// 			level = Math.min(4, Math.max(1, Math.ceil((count / maxCount) * 4)));
	// 		}

	// 		return {
	// 			date: item.day,
	// 			count,
	// 			level,
	// 		};
	// 	});
	// };

	loadEducationData = () => {
        const userID = utils.getCurrentUserID();

		this.setState({
			isLoadingEducation: true,
			educationErrorText: '',
		});

		utils.sendRequest('/education/getUserEducationList', { nickname: this.state.nickname })
			.then((responseData) => {
				this.setState({
					isLoadingEducation: false,
					educationList: responseData.educationList || [],
				});
			})
			.catch((error) => {
				console.log('education load error', error);
				this.setState({
					isLoadingEducation: false,
					educationErrorText: 'Could not load education right now.',
				});
			});
	};

	openAddEducationDialog = () => {
		this.setState({
			isAddEditEducationDialogOpen: true,
			editingEducationUserSchoolMajorID: null,
			newEducationText: '',
			saveEducationErrorText: '',
		});
	};

	closeAddEducationDialog = () => {
		this.setState({
			isAddEditEducationDialogOpen: false,
			editingEducationUserSchoolMajorID: null,
			saveEducationErrorText: '',
		});
	};

	getEducationUserSchoolMajorID = (item) => {
		if (!item) {
			return null;
		}

		const userSchoolMajorID = Number(item.userSchoolMajorId);
		if (!Number.isInteger(userSchoolMajorID) || userSchoolMajorID <= 0) {
			return null;
		}

		return userSchoolMajorID;
	};

	onNewEducationTextChange = (event) => {
		this.setState({
			newEducationText: event.target.value,
		});
	};

	isEducationDeleting = (userSchoolMajorID) => {
		return (this.state.deletingEducationIDs || []).includes(userSchoolMajorID);
	};

	setEducationMenuRef = (userSchoolMajorID, node) => {
		if (!Number.isInteger(userSchoolMajorID) || userSchoolMajorID <= 0) {
			return;
		}

		if (node) {
			this.educationMenuRefs[userSchoolMajorID] = node;
			return;
		}

		delete this.educationMenuRefs[userSchoolMajorID];
	};

	onDocumentPointerDown = (event) => {
		const openEducationMenuID = Number(this.state.openEducationMenuID);

		if (Number.isInteger(openEducationMenuID) && openEducationMenuID > 0) {
			const activeEducationMenuRoot = this.educationMenuRefs[openEducationMenuID];

			if (!activeEducationMenuRoot || !activeEducationMenuRoot.contains(event.target)) {
				this.setState({
					openEducationMenuID: 0,
				});
			}
		}
	};

	toggleEducationMenu = (userSchoolMajorID) => {
		this.setState((prevState) => ({
			openEducationMenuID: prevState.openEducationMenuID === userSchoolMajorID ? 0 : userSchoolMajorID,
		}));
	};

	openEditEducationDialog = (item) => {
		const userSchoolMajorID = this.getEducationUserSchoolMajorID(item);

		if (!Number.isInteger(userSchoolMajorID) || userSchoolMajorID <= 0) {
			return;
		}

		this.setState({
			openEducationMenuID: 0,
			isAddEditEducationDialogOpen: true,
			editingEducationUserSchoolMajorID: userSchoolMajorID,
			newEducationText: item.rawUserSchoolMajorText || '',
			saveEducationErrorText: '',
		});
	};

	openDeleteEducationDialog = (item) => {
		const userSchoolMajorID = this.getEducationUserSchoolMajorID(item);

		if (!Number.isInteger(userSchoolMajorID) || userSchoolMajorID <= 0 || this.isEducationDeleting(userSchoolMajorID)) {
			return;
		}

		this.setState({
			openEducationMenuID: 0,
			confirmDeleteEducationID: userSchoolMajorID,
		});
	};

	closeDeleteEducationDialog = () => {
		this.setState({
			confirmDeleteEducationID: 0,
		});
	};

	onDeleteEducationDialogPrimaryClick = () => {
		const userSchoolMajorID = Number(this.state.confirmDeleteEducationID);

		this.setState({
			confirmDeleteEducationID: 0,
		}, () => {
			this.deleteEducation(userSchoolMajorID);
		});
	};

	deleteEducation = (userSchoolMajorIDInput) => {
		const userSchoolMajorID = Number(userSchoolMajorIDInput);

		if (!Number.isInteger(userSchoolMajorID) || userSchoolMajorID <= 0 || this.isEducationDeleting(userSchoolMajorID)) {
			return;
		}

		this.setState((prevState) => ({
			openEducationMenuID: 0,
			confirmDeleteEducationID: 0,
			deletingEducationIDs: Array.from(new Set([...prevState.deletingEducationIDs, userSchoolMajorID])),
			educationErrorText: '',
		}), () => {
			utils.sendRequest('/education/deleteEducation', {
				userSchoolMajorID,
			})
				.then(() => {
					this.setState((prevState) => ({
						educationList: prevState.educationList.filter((education) => Number(education.userSchoolMajorId) !== userSchoolMajorID),
						deletingEducationIDs: prevState.deletingEducationIDs.filter((currentUserSchoolMajorID) => currentUserSchoolMajorID !== userSchoolMajorID),
					}));
				})
				.catch((error) => {
					console.log('delete education error', error);

					this.setState((prevState) => ({
						deletingEducationIDs: prevState.deletingEducationIDs.filter((currentUserSchoolMajorID) => currentUserSchoolMajorID !== userSchoolMajorID),
						educationErrorText: error && error.message ? error.message : 'Could not delete the education right now.',
					}));
				});
		});
	};

	onAddEducationSave = () => {
		const userID = utils.getCurrentUserID();
		const normalizedEducationText = (this.state.newEducationText || '').trim();
		const userSchoolMajorID = Number(this.state.editingEducationUserSchoolMajorID);
		const normalizedUserSchoolMajorID = Number.isInteger(userSchoolMajorID) && userSchoolMajorID > 0 ? userSchoolMajorID : null;

		if (!Number.isInteger(userID) || userID <= 0) {
			this.setState({
				saveEducationErrorText: 'Could not identify your account. Please sign in again.',
			});
			return;
		}

		if (normalizedEducationText === '') {
			this.setState({
				saveEducationErrorText: 'Please enter your education details before adding.',
			});
			return;
		}

		this.setState({
			isAddEditEducationDialogOpen: false,
			isSavingEducation: true,
			openEducationMenuID: 0,
			saveEducationErrorText: '',
			newEducationText: '',
		}, () => {
			utils.sendRequest('/education/saveEducation', {
				userSchoolMajorID: normalizedUserSchoolMajorID,
				education: normalizedEducationText,
			})
				.then(() => {
					this.setState({
						isSavingEducation: false,
						editingEducationUserSchoolMajorID: null,
					});

					this.loadEducationData();
				})
				.catch((error) => {
					console.log('save education error', error);
					this.setState({
						isSavingEducation: false,
						editingEducationUserSchoolMajorID: null,
						saveEducationErrorText: 'Could not add education right now. Please try again shortly.',
					});
				});
		});
	};

	// getLatestActiveDate = () => {
	// 	const {
	// 		contributionGraph,
	// 	} = this.state;

	// 	for (let index = contributionGraph.length - 1; index >= 0; index--) {
	// 		if ((contributionGraph[index].count || 0) > 0) {
	// 			return contributionGraph[index].date;
	// 		}
	// 	}

	// 	return 'No activity yet';
	// };

	formatYear = (value) => {
		if (value === null || value === undefined || value === '') {
			return 'Year not listed';
		}

		return `Class of ${value}`;
	};

	renderDeleteEducationDialog = () => {
		const userSchoolMajorID = Number(this.state.confirmDeleteEducationID);

		if (!Number.isInteger(userSchoolMajorID) || userSchoolMajorID <= 0) {
			return null;
		}

		const dialogNode = (
			<HQDialog
				title="Delete Education"
				message="Are you sure you want to delete this education item?"
				primaryButtonText="Delete"
				onPrimaryClick={this.onDeleteEducationDialogPrimaryClick}
				onCancelClick={this.closeDeleteEducationDialog}
				isPrimaryDisabled={this.isEducationDeleting(userSchoolMajorID)}
			/>
		);

        const portalNode = typeof this.props.getDialogPortalNode === 'function'
			? this.props.getDialogPortalNode()
			: this.props.dialogPortalNode;

		if (portalNode) {
			return ReactDOM.createPortal(dialogNode, portalNode);
		}

		return dialogNode;
	};

	renderAddEditEducationDialog = () => {
		const {
			isAddEditEducationDialogOpen,
			newEducationText,
			editingEducationUserSchoolMajorID,
		} = this.state;

		if (!isAddEditEducationDialogOpen) {
			return null;
		}

		const dialogNode = (
			<div className={styles.dialogOverlay} onClick={this.closeAddEducationDialog}>
				<div className={styles.dialogCard} onClick={(event) => event.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="add-education-title">
					<button
						type="button"
						className={styles.dialogCloseButton}
						onClick={this.closeAddEducationDialog}
						aria-label="Close add education dialog"
					>
						<FiX />
					</button>

					<h3 id="add-education-title" className={styles.dialogTitle}>{editingEducationUserSchoolMajorID ? 'Edit Education' : 'Add New Education'}</h3>
					<p className={styles.dialogSubtitle}>Tell us about your education: school name, city, state, ZIP, major, degree type, focus, and year</p>

					<textarea
						className={styles.dialogTextarea}
						value={newEducationText}
						onChange={this.onNewEducationTextChange}
						placeholder="School name, city, state, ZIP, major, degree type, focus, and year"
						rows={6}
					/>

					<div className={styles.dialogActions}>
						<button
							type="button"
							className={`${styles.primaryButton} ${styles.dialogPrimaryButton}`}
							onClick={this.onAddEducationSave}
						>
							{editingEducationUserSchoolMajorID ? 'Save' : 'Add'}
						</button>
					</div>
				</div>
			</div>
		);

		const portalNode = typeof this.props.getDialogPortalNode === 'function'
			? this.props.getDialogPortalNode()
			: this.props.dialogPortalNode;

		if (portalNode) {
			return ReactDOM.createPortal(dialogNode, portalNode);
		}

		return dialogNode;
	};

    render() {
		const {
			isLoadingEducation,
			isSavingEducation,
			educationErrorText,
			saveEducationErrorText,
			educationList,
			openEducationMenuID,
			editingEducationUserSchoolMajorID,
		} = this.state;

		return (
			<>
				<div className={styles.sectionHeader}>
					<h2 className={styles.formTitle}><FiAward /> Education</h2>
					<p className={styles.formText}>Academic history, majors, and school records tied to your profile.</p>
					{isSavingEducation && (
						<div className={styles.statusText}>
							{editingEducationUserSchoolMajorID ? 'Saving your education updates' : 'Adding your new education'}
						</div>
					)}
				</div>

				{educationErrorText !== '' && <div className={styles.errorBox}>{educationErrorText}</div>}
				{saveEducationErrorText !== '' && <div className={styles.errorBox}>{saveEducationErrorText}</div>}

				{isLoadingEducation && <div className={styles.loadingBox}>Loading education records...</div>}

				{!isLoadingEducation && educationList.length === 0 && (
					<div className={styles.emptyBox}>No education records were found for this profile.</div>
				)}

				{!isLoadingEducation && educationList.length > 0 && (
					<div className={styles.profileList}>
						{educationList.map((item) => {
							const userSchoolMajorID = this.getEducationUserSchoolMajorID(item);
							const isMenuOpen = openEducationMenuID === userSchoolMajorID;
							const canEditEducation = userSchoolMajorID !== null;
							const isDeletingEducation = Number.isInteger(userSchoolMajorID) ? this.isEducationDeleting(userSchoolMajorID) : false;

							return (
								<article key={`${item.schoolId}-${item.majorName}-${item.year || 'year'}`} className={`${styles.profileCard}${isDeletingEducation ? ` ${styles.updateCardDeleting}` : ''}`}>
									<div className={styles.profileCardHeader}>
										<div className={styles.profileCardHeadingGroup}>
											<h3 className={styles.profileCardTitle}>{item.name || 'Unnamed school'}</h3>
											<p className={styles.profileCardSubtitle}>{item.majorName || 'Major not listed'}</p>
										</div>
										<div className={styles.updateActions} ref={(node) => this.setEducationMenuRef(userSchoolMajorID, node)}>
											<span className={styles.profileCardBadge}><FiCalendar /> {this.formatYear(item.year)}</span>
											{canEditEducation && (
												<>
													<button
														type="button"
														className={styles.updateMenuButton}
														onClick={() => this.toggleEducationMenu(userSchoolMajorID)}
														aria-label="Open education actions"
														aria-expanded={isMenuOpen}
														disabled={isDeletingEducation}
													>
														<FiMoreVertical />
													</button>

													{isMenuOpen && (
														<div className={styles.updateMenu} role="menu" aria-label="Education actions">
															<button
																type="button"
																className={styles.updateMenuItem}
																onClick={() => this.openEditEducationDialog(item)}
																disabled={isDeletingEducation}
																role="menuitem"
															>
																Edit Education
															</button>
															<button
																type="button"
																className={styles.updateMenuItemDelete}
																onClick={() => this.openDeleteEducationDialog(item)}
																disabled={isDeletingEducation}
																role="menuitem"
															>
																Delete
															</button>
														</div>
													)}
												</>
											)}
										</div>
									</div>

									<p className={styles.profileCardBody}>
										{item.degree || 'Degree not listed'}
										{item.focus ? ` • ${item.focus}` : ''}
										{item.description ? ` • ${item.description}` : ''}
									</p>

									<div className={styles.profileCardMetaRow}>
										<span className={styles.profileCardMetaChip}><FiMapPin /> {[item.city, item.state, item.country].filter(Boolean).join(', ') || 'Location not listed'}</span>
										<span className={styles.profileCardMetaChip}><FiAward /> {item.majorName || 'Major not listed'}</span>
									</div>
								</article>
							);
						})}
					</div>
				)}

				<div className={styles.sectionFooterActions}>
					<button
						type="button"
						className={styles.secondaryButton}
						onClick={this.openAddEducationDialog}
					>
						<FiPlus /> Add Education
					</button>
				</div>

				{this.renderDeleteEducationDialog()}
				{this.renderAddEditEducationDialog()}
			</>
		);
	};
};